import { useDispatch, useSelector } from "react-redux";
import { useProperty } from "../../../PropertyContext";
import { useState } from "react";
import { fetchVoucherOffers, saveVoucherOffer } from "../../../Redux/Slices/voucherOffersSlice";
import swal from "sweetalert";
export const AddVoucherOffer = () => {

    const { selectedProperty } = useProperty();
    const dispatch = useDispatch();
    const { offersList } = useSelector(state => state.voucherOffers);

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title.trim() || !description.trim()) {
            swal("Warning!", "Please fill all fields", "warning");
            return;
        }

        // ✅ SortOrder Logic (Same Pattern)
        const sortOrder =
            offersList && offersList.length > 0
                ? Math.max(...offersList.map(item => item.SortOrder)) + 1
                : 0;

        const postData = {
            PropertyID: selectedProperty.PropertyID,
            Title: title,
            Description: description,
            SortOrder: sortOrder
        };

        try {
            const resultAction = await dispatch(saveVoucherOffer(postData));

            if (saveVoucherOffer.fulfilled.match(resultAction)) {

                await swal("Success!", "Voucher Offer Added Successfully", "success");

                // Refresh list
                dispatch(fetchVoucherOffers(selectedProperty.PropertyID));

                // Clear form
                setTitle("");
                setDescription("");

                // ✅ Close Modal (Bootstrap 5 way)
                const modalElement = document.getElementById("Add-Voucer-Offer");
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                modalInstance.hide();

            } else {
                swal("Error!", "Something went wrong", "error");
            }

        } catch (error) {
            swal("Error!", "Failed to save data", "error");
        }
    };
    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="row">

                    <div className="col-md-12 mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>

                    <div className="col-md-12">
                        <textarea
                            rows={2}
                            className="form-control"
                            placeholder="Enter Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    <div className="col-md-12">
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </div>

                </div>
            </form>
        </>
    )
}
